const withObjectUrl = async <T>(blob: Blob, callback: (url: string) => T | Promise<T>): Promise<T> => {
	const url = URL.createObjectURL(blob);
	try {
		return await callback(url);
	} finally {
		URL.revokeObjectURL(url);
	}
};

export default withObjectUrl;
